module.exports = __webpack_public_path__ + "assets/img/ljs.8bb3b907.png";